import type { Locale } from '@wms/shared';

import enCommon from '../locales/en/common.json' with { type: 'json' };
import enErrors from '../locales/en/errors.json' with { type: 'json' };
import esCommon from '../locales/es/common.json' with { type: 'json' };
import esErrors from '../locales/es/errors.json' with { type: 'json' };
import zhCommon from '../locales/zh-Hans/common.json' with { type: 'json' };
import zhErrors from '../locales/zh-Hans/errors.json' with { type: 'json' };

export const NAMESPACES = ['common', 'errors'] as const;
export type Namespace = (typeof NAMESPACES)[number];

export const DEFAULT_NAMESPACE: Namespace = 'common';

export const resources: Record<Locale, Record<Namespace, unknown>> = {
  en: { common: enCommon, errors: enErrors },
  es: { common: esCommon, errors: esErrors },
  'zh-Hans': { common: zhCommon, errors: zhErrors },
};

/** 供 i18next TypeScript 类型增强使用的基准资源（以 en 为准） */
export type Resources = (typeof resources)['en'];
